import React from "react";
import "./styles.css";

interface Iprops {
  setHoverMarcas: any;
}

const MarcasSubMenu: React.FC<Iprops> = ({
  setHoverMarcas,
}) => {
  return (
    <div
      onMouseOver={() => setHoverMarcas(true)}
      onMouseLeave={() => setHoverMarcas(false)}
      className="MarcasSubMenu"
    >
      <div className="MarcasSubMenu_relative">
    <div className="MarcasSubMenu_relative_list" >
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1667087748/pngegg_etikmq.png"/>
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1667087748/pngegg_etikmq.png"/>
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1667087748/pngegg_etikmq.png"/>
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1667087748/pngegg_etikmq.png"/>
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1667087748/pngegg_etikmq.png"/>
        </div>
        <div className="color__second__marcas"></div>
      </div>
    </div>
  );
};

export default MarcasSubMenu;
